// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
var codePoint = /(?:[^\uD800-\uDFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF])/;
export default codePoint;


//////////////////
// WEBPACK FOOTER
// ./node_modules/twitter-text/dist/esm/regexp/codePoint.js
// module id = 396
// module chunks = 110